'use client'

import { Builder } from '@builder.io/react'

import { SignUp } from './SignUp'
import { defaultProps } from './SignUp.defaults'

Builder.registerComponent(SignUp, {
  name: 'SignUpForm',
  noWrap: true,
  inputs: [
    {
      name: 'termsAndConditionsLink',
      type: 'string',
      defaultValue: defaultProps.termsAndConditionsLink,
    },
    {
      name: 'buttonTestId',
      type: 'string',
      defaultValue: 'continue_btn',
    },
    {
      name: 'privacyPolicyLink',
      type: 'string',
      defaultValue: defaultProps.privacyPolicyLink,
    },
    {
      name: 'emailFields',
      type: 'object',
      defaultValue: defaultProps.emailFields,
      subFields: [
        {
          name: 'freeUserRedirectURL',
          defaultValue: defaultProps.emailFields.freeUserRedirectURL,
          type: 'text',
        },
        {
          name: 'buttonText',
          defaultValue: defaultProps.emailFields.buttonText,
          type: 'text',
        },
      ],
    },
    {
      name: 'passwordFields',
      type: 'object',
      defaultValue: defaultProps.passwordFields,
      subFields: [
        {
          name: 'redirectURL',
          defaultValue: defaultProps.passwordFields.redirectURL,
          type: 'text',
        },
        {
          name: 'buttonText',
          defaultValue: defaultProps.passwordFields.buttonText,
          type: 'text',
        },
        {
          name: 'ruleMinEightMaxTwentyChars',
          defaultValue: defaultProps.passwordFields.ruleMinEightMaxTwentyChars,
          type: 'text',
        },
        {
          name: 'ruleOneUpper',
          defaultValue: defaultProps.passwordFields.ruleOneUpper,
          type: 'text',
        },
        {
          name: 'ruleOneLower',
          defaultValue: defaultProps.passwordFields.ruleOneLower,
          type: 'text',
        },
        {
          name: 'ruleOneNumber',
          defaultValue: defaultProps.passwordFields.ruleOneNumber,
          type: 'text',
        },
        {
          name: 'ruleNoBannedChars',
          defaultValue: defaultProps.passwordFields.ruleNoBannedChars,
          type: 'text',
        },
      ],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/forms.svg',
})
